import reduce from "lodash/reduce";

/**
 * Remove some caracteres from a string
 * @param {String} str String
 * @return {String}
 *
 * @example
 * import trimMask from '@meta-awesome/functions/src/trimMask'
 *
 * trimMask('123.456.789-55')
 * // 12345678955
 *
 * trimMask('(55) 12345-6789')
 * // 55123456789
 * */
const trimMask = (str = '') => {
  const specialChars = [" ", ".", "_", "-", "(", ")", "/"];

  return reduce(
    specialChars,
    (strTrim, char) => strTrim.split(char).join(""),
    str
  );
};

export default trimMask;
